import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button } from 'grommet'
import { HeaderOne } from 'secondstep-components'
import {
  getHighlightColor,
  getBackgroundGradient,
} from 'utils/highschoolHelpers'
import { variables } from 'themes'
import { DefaultSiteSelectorWrapper } from 'components/SiteSelector'
import { MarkdownParagraph } from 'components/MarkdownComponent'

export const tabTheme = {
  colors: {
    buttons: {
      tabActive: variables.colors.hsPrimaryPink,
      tabDefault: variables.colors.darkGray,
    },
  },
  font: {
    molde: {
      medium: variables.font.molde.medium,
      regular: variables.font.molde.regular,
      semiBold: variables.font.molde.semiBold,
    },
  },
}

export const ActivityButton = styled(Button)`
  background: ${themeGet('colors.buttons.primary.bgActive')};
  color: ${themeGet('colors.buttons.primary.titleActive')};
  border-radius: 0.5rem;
  padding: 21px;
  padding-top: 0.688rem;
  padding-bottom: 0.563rem;
  margin-bottom: 21px;
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1rem;
  text-align: center;
  ${themeGet('breakpoints.mobileLarge')} {
    border-radius: 0.3rem;
    margin-bottom: 2.55rem;
  }
  :hover {
    background: ${themeGet('colors.buttons.primary.bgHover')};
    color: ${themeGet('colors.buttons.primary.titleHover')};
  }
`

export const AudienceTagContainer = styled.div`
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1.75rem;
  ${themeGet('breakpoints.mobileLarge')} {
    justify-content: center;
    margin-top: 1.25rem;
    margin-bottom: 1.75rem;
  }
  ${themeGet('breakpoints.tabletLarge')} {
    justify-content: center;
    margin-top: 1.25rem;
    margin-bottom: 1.75rem;
  }
  div {
    background-color: ${props =>
      props.isHighSchool
        ? getHighlightColor(props.audience)
        : themeGet('individualResource.audienceTag.backgroundColor')};

    color: ${themeGet('individualResource.audienceTag.color')};
    border-radius: 0.3rem;
    padding: 0rem 0.75rem;
    font-size: 0.75em;
  }
`

export const ControlPanel = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 1.25rem 3.5625rem 1.25rem;
  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: ${themeGet('breakpoints.sizes.large')};
    ${themeGet('breakpoints.mobileLarge')} {
      flex-direction: column-reverse;
      padding-bottom: 0.125rem;
    }
  }

  // targets the TabSet buttons:
  [class*='StyledGrommet'] {
    align-self: last baseline;
    margin-bottom: 1.3rem;
    ${themeGet('breakpoints.mobileLarge')} {
      align-self: first baseline;
    }
  }
`

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding-bottom: 2.5rem;
  background: ${props =>
    props.isHighSchool ? getBackgroundGradient(props.audience) : '#eef0f2'};
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: ${themeGet('breakpoints.sizes.large')};
  }
`

export const ExternalLinkIcon = styled.img`
  margin-left: 0.5rem;
  margin-bottom: -0.15rem;
`
export const ResourceImageContainer = styled.img`
  ${themeGet('breakpoints.tabletLarge')} {
    order: -1;
  }
`

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 1.3rem;
  ${themeGet('breakpoints.large')} {
    margin: 1.3rem 1.25rem;
  }
  ${themeGet('breakpoints.mobileLarge')} {
    margin: 1.3rem 1rem;
  }
  .content {
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: ${themeGet('breakpoints.sizes.large')};
    ${themeGet('breakpoints.mobileLarge')} {
      flex-direction: column-reverse;
      align-items: center;
      text-align: center;
    }
    ${themeGet('breakpoints.tabletLarge')} {
      flex-direction: column;
      align-items: center;
      text-align: center;
    }
  }

  .resource-image {
    // fixed dimensions on desktop
    width: 21.438rem;
    height: 11.625rem;
    ${themeGet('breakpoints.mobileLarge')} {
      width: unset;
      height: unset;
      max-width: 100%;
    }
  }
`

export const PageContainer = styled.div`
  width: 100%;
  // background-color: #eef0f2;
`

export const StyledHeaderOne = styled(HeaderOne)`
  color: ${themeGet('colors.heading.level.1')};
  font-family: ${themeGet('individualResource.h1.fontFamily')};
  ${themeGet('breakpoints.mobileLarge')} {
    text-align: center;
  }
  ${themeGet('breakpoints.tabletLarge')} {
    text-align: center;
  }
`

export const SurveyLink = styled.a`
  display: block;
  color: ${themeGet('colors.highschool.green2')};
  font-family: ${themeGet('font.molde.medium')};
  font-size: 1.125rem;
  text-decoration: none;
  margin-top: 1.563rem;
  :visited {
    color: ${themeGet('colors.highschool.green2')};
  }
  :focus,
  :hover {
    color: ${themeGet('colors.highschool.green1')};
  }
`

export const BannerSpacer = styled.div`
  margin-top: 6.99rem;
  div {
    margin-top: -6.99rem !important;
  }
`
export const SiteSelectorWrapper = styled(DefaultSiteSelectorWrapper)`
  margin: auto;
  max-width: ${themeGet('breakpoints.sizes.large')};
  padding-right: 0;
  padding-top: 0;
  margin-top: ${props => (props.isHighSchool ? '1.593rem' : 'inherit')};
  ${themeGet('breakpoints.large')} {
    padding-right: 1rem;
  }
`

export const HsIndividualResourceMarkCompleteWrapper = styled.div`
  margin-top: 1.5rem;
`

export const HeaderTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  ${themeGet('breakpoints.mobileLarge')} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
  ${themeGet('breakpoints.tabletLarge')} {
    flex-direction: column;
    align-items: center;
    text-align: center;
  }
`

export const TitleWrapper = styled.div`
  flex: 1;
  max-width: calc(100% - 200px);

  ${themeGet('breakpoints.mobileLarge')} {
    max-width: 100%;
  }
  ${themeGet('breakpoints.tabletLarge')} {
    max-width: 100%;
  }
`

export const HeaderContentWrapper = styled.div`
  width: ${props => (props.isHighSchool ? 'auto' : '100%')};
  ${themeGet('breakpoints.tabletLarge')} {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    width: 100%;

    p {
      max-width: 21.4375rem; /* 343px */
    }
  }
`

export const MetadataContainer = styled.div`
  margin-bottom: ${props => (!props.isHighSchool ? '4.8125rem' : '0')};
`
export const ResourceContainer = styled.div`
  background-color: ${props =>
    !props.isHighSchool ? '#eef0f2' : 'transparent'};
`

export const BreadcrumbWrapper = styled.nav`
  display: flex;
  align-items: flex-start;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};
  margin: auto;
  padding: 20px 1.25rem 1.625rem 0;

  ${themeGet('breakpoints.mobileLarge')} {
    padding-left: 1rem;
    padding-right: 1rem;
  }
  ${themeGet('breakpoints.large')} {
    padding-left: 1.25rem;
  }
`
export const NavigationWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  max-width: ${themeGet('breakpoints.sizes.large')};
  margin: auto;
`

export const StyledMarkdownParagraph = styled(MarkdownParagraph)`
  margin-bottom: 1rem;
  line-height: 1.5;
  ${themeGet('breakpoints.tabletLarge')} {
    display: flex;
    justify-content: center;
    margin-bottom: 0;
  }
`

export const PreviewBannerWrapper = styled.div`
  > div:nth-child(2) {
    margin-top: -6.99rem !important;
  }
`
